<template>
  <el-card shadow="always">
    <div class="title-wrap" v-if="pagesIndex == 'internationalFair'">
      <div class="title">
        <div class="title-top"> 
          <div class="title-top-span">
            <span v-if="lan == 'ch'">2020年中国进博国际货代云展：云约全球，对接中国</span>
            <span v-else>2020 CIIE International Forwarders'Cloud Expo. : Connecting China with the World Through Cloud</span>
          </div>
          <div class="btn-wrap">
            <!--我要报名-->
            <el-button type="primary" class="btn" style="height: 40px" @click="detailsInformationHandleRegister()">
            {{language.OnlineExhibitorRegister}}
            </el-button>
            
            <!--我要支付-->
            <el-button type="primary" class="btn" style="height: 40px;background: linear-gradient(0deg, rgb(236, 141, 55), rgb(239, 106, 40)) !important;"  @click="detailsInformationHandleRegister()" >
            {{language.OnlineVisitorRegister}}
            </el-button>
          </div>
        </div>

        <div v-if="lan == 'ch'" class="title-content">
          <p>展会时间：2020年11月6-9日，每天云展对接时间09：00-22：00（北京时间）</p>
          <p>主办方：WIFFA国际货代联合会（香港）</p>
          <p>协办方：中国国际海运网，中国物流与采购联合会国际货代分会 </p>
        </div>
        <div v-if="lan == 'en'" class="title-content">
          <p>Time: 6-9 November 2020,  09:00-22:00 (Beijing time) every day  </p>
          <p>Host: WIFFA (Hong Kong) International Freight Forwarders Alliance</p>
          <p>Organizers: Shippingchina, International Freight Forwarding Branch of China Federation of Logistics and Purchasing     </p>
        </div>
      </div>
    </div>
    <div v-html="details"></div>
  </el-card>
</template>

<script>

  import {language} from "../../../language/get";
  import Cookie from "../../../common/cookie";
  // const lan = language();
  export default {
    props: {
      details: {
        type: String,
        default: ""
      },
      pagesIndex:{
        type: String,
        default: ""
      }
    },
    
    data() {
        return {
          lan: Cookie.get("lang"),
          language: language()
        }
    },
    
    methods: {
      detailsInformationHandleRegister(){
        this.$emit("detailsInformationHandleRegister", '');
      }
    }
  }
</script>

<style scoped>
  .title-wrap{
    background: #f2f2f2;
    margin-bottom: 20px;
  }
  .title{
    /* flex: 1; */
    text-align: left;
    margin: 0 auto;
    color: #333;
    /* height: 40px;
    line-height: 40px; */
    padding-left: 20px;
    padding: 20px;

  }
  .title-top{
    display: flex;
  }
  .title-top-span{
    flex: 1;
    font-size: 22px;
  }
  .title-top-span span{
    font-weight: bold;
  }
  .title-content{
    padding-top: 5px;
  }
  .btn-wrap{
    display: inline-block;
  }
  .btn{
    /* display: inline-block; */
    background: #0f408a;
    border-color: #0f408a;
  }
  .title-wrap >>> .el-button--primary:hover {
    background: #0f408a !important;
    border-color: #0f408a !important;
    color: #FFF !important;
  }
</style>